
function correctLocation(win, history) {

  var loc = win.location.href.replace('.html','/');

  if (history && history.pushState) {
    history.pushState({'html':false}, '', loc);
  }

  return;

}


function decodeHtml(input) {

  var e = document.createElement('div');
  e.innerHTML = input;

  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;

}

function parseYoutube(url) {

  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);

  if (match && match[7].length === 11) {
    return match[7];
  }

}

function replaceHistoryState(win, history) {

  const { href, search } = win.location;

  if (history.replaceState) {

    setTimeout(()  => {
      history.replaceState(null, null, href.replace(search,''));
    }, 5000);

  }

  return;

}

function setCurrentDate() {

  var d = new Date();
  var year = d.getFullYear();
  $('.year').text(year);

}

//for ajax calls
function redirect(data) {
  return data;
}

function licgen(data) {
  return data
}

function placeholder(id, hint) {
  $(id).attr('placeholder', hint);
};


module.exports = {

  correctLocation,
  decodeHtml,
  parseYoutube,
  replaceHistoryState,
  setCurrentDate,
  placeholder,

  ajaxCalls: {
    licgen,
    redirect
  }

};



// WEBPACK FOOTER //
// ./src/utils.js